'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'inbox';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f01c';
var svgPathData = 'M48 336l0 96 416 0 0-96-83.2 0c-19.5 29.3-30.2 45.3-32 48l-185.7 0c-1.8-2.7-12.5-18.7-32-48L48 336zm415.6-48l-26-208-363.3 0-26 208 108.5 0c1.8 2.7 12.5 18.7 32 48l134.3 0c19.5-29.3 30.2-45.3 32-48l108.5 0zM0 288l32-256 448 0 32 256 0 192-512 0 0-192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faInbox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;